module.exports = __webpack_public_path__ + "static/media/calculating.3b627d6c.png";